var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3553_2525)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6ZM4.125 3.9375C4.125 3.73359 4.23516 3.54609 4.41328 3.44766C4.5 3.40078 4.59375 3.375 4.6875 3.375C4.78828 3.375 4.89141 3.40313 4.98047 3.45703L8.35547 5.51953C8.52188 5.62266 8.625 5.80312 8.625 6C8.625 6.19688 8.52188 6.37734 8.35547 6.48047L4.98047 8.54297C4.80703 8.64844 4.58906 8.65312 4.41094 8.55469C4.23281 8.45625 4.12266 8.26875 4.12266 8.06484V3.93984L4.125 3.9375Z",
    fill: "#1B467A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98037 3.45696C4.80693 3.35149 4.58896 3.3468 4.41084 3.44524C4.23271 3.54368 4.12256 3.73352 4.12256 3.93508V8.06008C4.12256 8.26399 4.23271 8.45149 4.41084 8.54993C4.58896 8.64837 4.80459 8.64602 4.98037 8.53821L8.35537 6.47571C8.52178 6.37258 8.6249 6.19212 8.6249 5.99524C8.6249 5.79837 8.52178 5.6179 8.35537 5.51477L4.98037 3.45227V3.45696Z",
    fill: "#1B467A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3553_2525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circle-play.429281f5ddbee6fadaff745b04b7001f.svg";
export { ForwardRef as ReactComponent };